import { render } from "./TopUpVoucherSuccess.vue?vue&type=template&id=40093003&scoped=true"
import script from "./TopUpVoucherSuccess.vue?vue&type=script&lang=js"
export * from "./TopUpVoucherSuccess.vue?vue&type=script&lang=js"

import "./TopUpVoucherSuccess.vue?vue&type=style&index=0&id=40093003&scoped=true&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40093003"]])

export default __exports__